"use strict";
(self["webpackChunklittle_sleepies"] = self["webpackChunklittle_sleepies"] || []).push([[2535],{

/***/ 2535:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ MultiVideoController)
/* harmony export */ });
function MultiVideoController({ wrapper }) {
  const controllerSelector = 'multiple-video-controller'
  const buttonSelector = 'button'
  const videoSelector = 'video'
  // Find all controllers in the context
  const controllers = wrapper.querySelectorAll(controllerSelector)

  controllers.forEach((controller) => {
    const videos = controller.querySelectorAll(videoSelector)
    const playButton = controller.querySelector(buttonSelector)

    if (!playButton) return

    // Remove any previous event listeners to avoid duplicates
    playButton.removeEventListener('click', playButton._multiVideoHandler)

    // Define the handler
    const handler = function (e) {
      playButton.disabled = true
      let videoEl
      videos.forEach((video) => {
        if (window.getComputedStyle(video).getPropertyValue('display') != 'none') {
          videoEl = video
        }
      })
      e.preventDefault()
      e.stopImmediatePropagation()
      if (videoEl && videoEl.paused) {
        videos.forEach((video) => video.play())
        playButton.dataset.isPlaying = 'true'
      } else {
        videos.forEach((video) => video.pause())
        playButton.dataset.isPlaying = 'false'
      }
      playButton.disabled = false
    }

    // Store handler reference for removal
    playButton._multiVideoHandler = handler
    playButton.addEventListener('click', handler)
  })
}


/***/ })

}]);